document.addEventListener('DOMContentLoaded', () => {
    const productHtml = document.querySelector('#product-thumbnail_slider');
    const product = JSON.parse(productHtml.innerText);
    const productVariants = product.product.variants;
    const selectedVariant = product.selected_variant;

    const selectedColorTitle = selectedVariant.title.toLowerCase();
    const sliderContainer = document.querySelector('.product-single__media-slider');
    const thumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail'));

    const allOriginalSlides = Array.from(sliderContainer.querySelectorAll('.product-single__media-slide'));

    function isExactVariantMatch(alt, variantTitle) {
        if (!alt || alt.trim() === '') {
            return true;
        }

        const cleanVariantTitle = variantTitle.trim().toLowerCase();

        const splitAlts = alt.split('#').map(part => part.trim().toLowerCase());

        for (let altPart of splitAlts) {
            if (altPart === cleanVariantTitle) {
                return true;
            }

            if (altPart.includes('_')) {
                const withSpaces = altPart.replace(/_/g, ' ');
                if (withSpaces === cleanVariantTitle) {
                    return true;
                }

                const withUnderscores = cleanVariantTitle.replace(/ /g, '_');
                if (altPart === withUnderscores) {
                    return true;
                }
            }
        }

        return false;
    }

    function doesAltMatchAnyVariant(alt) {
        if (!alt || alt.trim() === '') {
            return false;
        }


        return productVariants.some(variant => {
            const variantTitle = variant.title.toLowerCase();
            return isExactVariantMatch(alt, variantTitle);
        });
    }

    function shouldShowImage(alt, currentVariantTitle) {
        if (isExactVariantMatch(alt, currentVariantTitle)) {
            return true;
        }

        if (!alt || alt.trim() === '') {
            return true;
        }

        if (!doesAltMatchAnyVariant(alt)) {
            return true;
        }

        return false;
    }

    function hasMatchingThumbnails(variantTitle) {
        const allThumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail'));

        return allThumbnails.some(thumbnail => {
            const alt = thumbnail.querySelector('img')?.getAttribute('alt');
            return shouldShowImage(alt, variantTitle);
        });
    }

    if (!hasMatchingThumbnails(selectedColorTitle)) {
        return;
    }

    let flickityInstance = null;
    let matchedThumbnails = [];

    function removeOldThumbnailListeners() {
        const currentThumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail'));

        currentThumbnails.forEach(thumbnail => {
            if (thumbnail.parentNode) {
                const newThumbnail = thumbnail.cloneNode(true);
                thumbnail.parentNode.replaceChild(newThumbnail, thumbnail);
            }
        });

        return Array.from(document.querySelectorAll('.product-single__thumbnail'));
    }

    function addThumbnailClickListeners(visibleThumbnails, currentSlides) {

        const allCurrentThumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail'));
        const currentMatchedThumbnails = allCurrentThumbnails.filter(thumbnail => {
            return thumbnail.style.display !== 'none';
        });

        currentMatchedThumbnails.forEach(thumbnail => {
            if (thumbnail.parentNode) {
                const newThumbnail = thumbnail.cloneNode(true);
                thumbnail.parentNode.replaceChild(newThumbnail, thumbnail);
            }
        });

        const finalThumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail')).filter(thumbnail => {
            return thumbnail.style.display !== 'none';
        });

        let isDragging = false;

        finalThumbnails.forEach((thumbnail, thumbnailIndex) => {

            thumbnail.addEventListener('pointerdown', () => {
                isDragging = false;
            });

            thumbnail.addEventListener('pointermove', () => {
                isDragging = true;
            });

            thumbnail.addEventListener('click', (e) => {
              e.preventDefault();
                if (isDragging) {
                  
                    return;
                }

                if (flickityInstance && thumbnailIndex < currentSlides.length) {
                    flickityInstance.select(thumbnailIndex);
                }

                updateThumbnailActiveState(thumbnailIndex);
            });
        });

        matchedThumbnails = finalThumbnails;
    }

    function updateThumbnailActiveState(activeIndex) {
        matchedThumbnails.forEach((thumbnail, index) => {
            if (index === activeIndex) {
                thumbnail.classList.add('active');
            } else {
                thumbnail.classList.remove('active');
            }
        });
    }

    function syncThumbnailWithSlider() {
        if (!flickityInstance) return;
        flickityInstance.on('change', (index) => {
            updateThumbnailActiveState(index);
        });

    }

    function createNewSliderForVariant(variantTitle) {

        if (!hasMatchingThumbnails(variantTitle)) {
            return 0;
        }

        if (flickityInstance) {
            flickityInstance.destroy();
            flickityInstance = null;
        }

        sliderContainer.innerHTML = '';

        const matchingSlides = [];
        allOriginalSlides.forEach((originalSlide) => {
            const alt = originalSlide.querySelector('img')?.getAttribute('alt') || '';

            const shouldShow = shouldShowImage(alt, variantTitle);

            if (shouldShow) {
                const clonedSlide = originalSlide.cloneNode(true);
                matchingSlides.push(clonedSlide);
                sliderContainer.appendChild(clonedSlide);
            }
        });

        if (matchingSlides.length > 0) {
            flickityInstance = new Flickity(sliderContainer, {
                wrapAround: true,
                pageDots: false,
                adaptiveHeight: true,
                accessibility: false,
                cellAlign: 'left',
                contain: true,
                dragThreshold: 10,
                draggable: true
            });

            syncThumbnailWithSlider();
        } else {
            return 0;
        }

        const updatedThumbnails = Array.from(document.querySelectorAll('.product-single__thumbnail'));
        matchedThumbnails = [];

        updatedThumbnails.forEach((thumbnail) => {
            const alt = thumbnail.querySelector('img')?.getAttribute('alt');

            const shouldShow = shouldShowImage(alt, variantTitle);

            if (shouldShow) {
                thumbnail.style.display = 'block';
                matchedThumbnails.push(thumbnail);
            } else {
                thumbnail.style.display = 'none';
            }
        });

        if (matchedThumbnails.length > 0) {
          setTimeout(()=>{
                     matchedThumbnails.forEach((el, i) => {
                if (i === matchedThumbnails.length - 1) {
                    el.style.transform = `translateX(${i * 100}%)`;
                } else {
                    el.style.transform = `translateX(${i * 95}%)`;
                }
            });
          }, 500)
   

            addThumbnailClickListeners(matchedThumbnails, matchingSlides);

            updateThumbnailActiveState(0);
        }
flickityInstance.resize();

        return matchingSlides.length;
    }

    createNewSliderForVariant(selectedColorTitle);

  

    document.querySelector('[data-product-variant-select]').addEventListener('change', (event) => {
        const id = parseInt(event.target.value);
        const findVariant = productVariants.find((variant) => variant.id === id);

        if (findVariant) {
            const selectedVariantTitle = findVariant.title.toLowerCase();
            createNewSliderForVariant(selectedVariantTitle);
        }
    });

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        if (flickityInstance) {
            flickityInstance.destroy();
        }
    });
});